import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { SheetDb } from '../redux/sheetDbSlice';

const useAllSheetsDbByBooks = (bookIds: string[] | null) : [string[], SheetDb[]] => {
  const sheetDb = useSelector((state: RootState) => state.sheetDb);
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const sheetTreeIds: string[] = [];
  bookIds?.forEach((bookId) => {
    const additionalIds = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].bookId === bookId);
    sheetTreeIds.push(...additionalIds);
  });
  const ids = sheetTreeIds?.map(id => sheetTreeDb.sheetTrees[id].sheetId);
  const sheets = ids.map(id => sheetDb.sheets[id]);

  return [ids, sheets];
}

export default useAllSheetsDbByBooks;
